import React, {Component} from 'react'
import './InsuranceEligibilityScreen.css'
import {Col, Container, Nav, Row, Tab} from "react-bootstrap";
import PayAndClaim from "./claim/PayAndClaim";
import InsuranceDirect from "./direct/InsuranceDirectPay";
import InsuranceAppointment from "./appointment/InsuranceAppointment";
import ClaimList from "./claimList/ClaimList";
import queryString from "query-string";
import ClaimRemittance from "./claimRemittance/ClaimRemittance";
import AuthService from "../../../services/auth-service/AuthService";

export default class InsuranceEligibilityScreen extends Component {
    constructor(props) {
        super(props);

        this.tabVisibility = {
            todaysAppointments: AuthService.userHasAnyAuthority(["VIEW_INSURANCE_APPOINTMENTS", "UPDATE_INSURANCE_APPOINTMENTS"]),
            directBilling: AuthService.userHasAnyAuthority(["VIEW_INSURANCE_PRE_APPROVAL", "UPDATE_INSURANCE_PRE_APPROVAL"]),
            payAndClaim: AuthService.userHasAnyAuthority(["VIEW_INSURANCE_PAY_AND_CLAIM", "UPDATE_INSURANCE_PAY_AND_CLAIM"]),
            claimList: AuthService.userHasAnyAuthority(["VIEW_INSURANCE_CLAIM", "UPDATE_INSURANCE_CLAIM"]),
            claimRemittance: AuthService.userHasAuthority("VIEW_INSURANCE_CLAIM_REMITTANCE")
        };

        const values = queryString.parse(this.props.location.search);
        const requestedTab = values.selectedTab;
        const defaultTab = this.tabVisibility[requestedTab]
            ? requestedTab
            : Object.keys(this.tabVisibility).find(tab => this.tabVisibility[tab]) || "todaysAppointments";

        this.state = {selectedTab: defaultTab};
    }

    render() {
        const {selectedTab} = this.state;

        return (
            <Container style={{maxWidth: '100%'}}>
                <Row>
                    <Col xs={12}>
                        <div className="InsuranceScreen">
                            <Tab.Container defaultActiveKey={selectedTab} id="insurance-tabs"
                                           className="InsuranceTabs"
                                           onSelect={(key) => {
                                               this.setState({selectedTab: key})
                                               this.props.history.push({
                                                   search: "?" + new URLSearchParams({selectedTab: key}).toString()
                                               })
                                           }}>
                                <Row>
                                    <Col sm={12}>
                                        <Nav variant="tabs" className="flex-row">
                                            {this.tabVisibility.todaysAppointments &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="todaysAppointments">Appointments</Nav.Link>
                                            </Nav.Item>}
                                            {this.tabVisibility.directBilling &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="directBilling">Pre Approval</Nav.Link>
                                            </Nav.Item>}
                                            {this.tabVisibility.payAndClaim &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="payAndClaim">Pay&Claim</Nav.Link>
                                            </Nav.Item>}
                                            {this.tabVisibility.claimList &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="claimList">Claim</Nav.Link>
                                            </Nav.Item>}
                                            {this.tabVisibility.claimRemittance &&
                                            <Nav.Item>
                                                <Nav.Link eventKey="claimRemittance">Claim Remittance</Nav.Link>
                                            </Nav.Item>}
                                        </Nav>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <Tab.Content>
                                            {this.tabVisibility.todaysAppointments &&
                                            <Tab.Pane eventKey="todaysAppointments">
                                                <InsuranceAppointment selected={selectedTab === "todaysAppointments"} />
                                            </Tab.Pane>}
                                            {this.tabVisibility.directBilling &&
                                            <Tab.Pane eventKey="directBilling">
                                                <InsuranceDirect selected={selectedTab === "directBilling"} />
                                            </Tab.Pane>}
                                            {this.tabVisibility.payAndClaim &&
                                            <Tab.Pane eventKey="payAndClaim">
                                                <PayAndClaim
                                                    selected={selectedTab === "payAndClaim"} />
                                            </Tab.Pane>}
                                            {this.tabVisibility.claimList &&
                                            <Tab.Pane eventKey="claimList">
                                                <ClaimList selected={selectedTab === "claimList"} />
                                            </Tab.Pane>}
                                            {this.tabVisibility.claimRemittance &&
                                            <Tab.Pane eventKey="claimRemittance">
                                                <ClaimRemittance selected={selectedTab === "claimRemittance"} />
                                            </Tab.Pane>}
                                        </Tab.Content>
                                    </Col>
                                </Row>
                            </Tab.Container>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}
